import React, { useState, useEffect }  from 'react'

import img from '../images/MANHYIA.webp'
import img2 from '../images/cocobod.webp'
import img3 from '../images/banner7.webp'
import img4 from '../images/banner6.webp'
// import img5 from '../images/pathomas.webp'



export default function Banner() {

  const images = [
   
    img2,
   
    img4,
    // img5,
    img,
    img3,
    
   
  ];

const [currentIndex, setCurrentIndex] = useState(0);

useEffect(() => {
const interval = setInterval(() => {
setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
}, 5000); // Change every 5 seconds
return () => clearInterval(interval); // Cleanup interval on component unmount 
}, [images.length]);

  return (
    <div className=''>
      <div className='text-slate-900 shadow ' id='nav-bar' style={{backgroundImage: `url(${images[currentIndex]})`}}> 
      </div>   
    </div>
  )
}
